var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',_vm._g(_vm._b({staticClass:"fab rounded-circle",attrs:{"variant":"primary"}},'b-btn',_vm.$attrs,false),_vm.$listeners),[_c('i',{staticClass:"fa fa-plus"})])
}
var staticRenderFns = []

export { render, staticRenderFns }